import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/working_options.json";

export const useWorkingOptions = () => useSourceFlowCollection(data);

export default useWorkingOptions();
